import { loanResponseStatus } from '@repo/shared/types';
/**
 * Statusy, które przy stage 5 oznaczają pożyczkę zakończoną — taka pożyczka
 * nie blokuje już wyświetlenia ofert. DONE traktujemy jak zakończenie procesu
 * (stage 5 samo w sobie oznacza już proces zakończony).
 */
var INACTIVE_STATUSES = [
    loanResponseStatus.enum.CLOSED,
    loanResponseStatus.enum.REJECTED,
    loanResponseStatus.enum.TERMINATED,
    loanResponseStatus.enum.DONE,
];
/**
 * Pożyczka aktywna = wniosek w toku (stage < 5) albo pożyczka na stage 5
 * o statusie innym niż CLOSED / REJECTED / TERMINATED / DONE.
 * Priorytet widoków: aktywna pożyczka > oferty > pożyczki nieaktywne.
 */
export var hasUserActiveLoan = function (merchantResponseData) {
    return merchantResponseData.data.loans.some(function (loan) {
        return loan.stage < 5 ||
            (loan.stage === 5 && (!loan.status || !INACTIVE_STATUSES.includes(loan.status)));
    });
};
